module.exports = __webpack_public_path__ + "img/caidaoApp-3.d3925d9a.png";